import { TipoIdentificacion } from "./tipo-identificacion";

export class Cliente{
    public constructor(
        public id: String = "",
        public dni:String = "",
        public razon_social:String = "",
        public nombre_comercial:String = "",
        public correo:String = "",
        public telefono:String = "",
        public celular:String = "",
        public direccion:String = "",
        public tipo_dni :String = "",
        public tipo_persona :string = "",
        public es_obligado: boolean = false,
        public es_contribuyente: boolean = false,
        public num_contribuyente: string = "",
        public contribuyente: String = "",
        public empresa_id: String = "",
        public tipo_identificacion_id: number = 0,
        public usuario_id:String = null,

        public tipoidentificacion:TipoIdentificacion = new TipoIdentificacion(),


    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/cliente.ts